// 【公共组件】使用场景
export default {
    'useSence.tips1': '请选择使用场景',
    'useSence.tips2': '请选择使用场景(必选)' ,
}
 